import React, { useState, useCallback, useEffect } from 'react';
import { Input } from 'antd';
import { isNull } from 'lodash';
import cx from 'classnames';
import { isNil } from 'lodash';
import { setTrim } from '../../../lib/common';
import { REX_EXCEPT_NUMBER } from '../../../lib/rex';
import Button from '../../Button';
import './TableFilterInput.scss';

const TableFilterInput = (props) => {
  const { className, option, onFilter, setSelectedKeys, confirm, clearFilters, placeholder, type = 'text' } = props;

  /**
   *  함수형 컴포넌트에서 사용될 state 초기화
   */
  const [value, setValue] = useState(null);

  /**
   *  `option` props 가 변경이 있을 때, 실행됨.
   *   value 의 option 값으로 업데이트 함
   */
  useEffect(() => {
    setValue(option);
  }, [option]);

  /**
   *  input onchange event 가 발생을 할 때마다
   *  value 를 업데이트 함
   */
  const onChange = useCallback((e) => {
    let target = null;
    if (e.target.value !== '' && !isNil(e.target.value)) {
      if (type === 'number') {
        target = e.target.value.replace(REX_EXCEPT_NUMBER, '');
      } else {
        target = e.target.value;
      }
    }

    setValue(target);
  }, []);

  const onSearch = (value) => {
    confirm();

    onFilter && onFilter(value);
    setSelectedKeys && setSelectedKeys([value]);

    if (clearFilters && isNull(value)) {
      clearFilters();
      setValue(value);
    }
  };

  /**
   *  input element 의 focus 가 잡힌 상태에서
   *  `enter` 키를 누를 때마다, value 를 업데이트함
   *  그리고 onFilter 메소드를 통하여 서버로
   *  필터 옵션 값을 보냄
   */
  const onPressEnter = (e) => {
    let target = null;
    if (e.target.value !== '' && !isNil(e.target.value)) target = setTrim(e.target.value);

    onSearch(target);
  };

  const handleKeyDown = (e) => {
    //html input number에서 해당 문자를 숫자로 인식
    const invalidNumber = ['+', '-', 'e', '.'];
    if (type === 'number') {
      if (invalidNumber.includes(e.key)) e.preventDefault();
    }
  };

  return (
    <div className={cx('table-filter-input-wrap', className)}>
      <Input
        value={value}
        type={type}
        placeholder={placeholder}
        onPressEnter={onPressEnter}
        onChange={onChange}
        onKeyDown={handleKeyDown}
      />

      <Button color="primary" text="검색" onClick={() => onSearch(value)} />

      <Button color="light" text="초기화" onClick={() => onSearch(null)} />
    </div>
  );
};

export default TableFilterInput;
